"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = emailTypoSuggestion;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var PROVIDER_TYPOS = {
  gmial: 'gmail',
  gmal: 'gmail',
  gmai: 'gmail',
  gamil: 'gmail',
  gnail: 'gmail',
  gmail: 'gmail',
  hotmial: 'hotmail',
  hotmal: 'hotmail',
  hotmai: 'hotmail',
  hotmail: 'hotmail',
  outlok: 'outlook',
  oulook: 'outlook',
  outllook: 'outlook',
  outlook: 'outlook',
  yaho: 'yahoo',
  yaoo: 'yahoo',
  yahooo: 'yahoo',
  yahoo: 'yahoo',
  icoud: 'icloud',
  icloud: 'icloud'
};
var COM_TYPOS = ['con', 'cmo', 'comm', 'comn', 'om'];
function emailTypoSuggestion(email) {
  var atIndex = email.lastIndexOf('@');
  if (atIndex < 1) {
    return null;
  }
  var domain = email.slice(atIndex + 1).toLowerCase();
  var parts = domain.split('.');
  if (parts.length >= 2 && parts[parts.length - 1] === 'con') {
    var _provider = parts.length === 2 && Object.prototype.hasOwnProperty.call(PROVIDER_TYPOS, parts[0]) ? PROVIDER_TYPOS[parts[0]] : null;
    var _correctedDomain = _provider ? "".concat(_provider, ".com") : "".concat(domain.slice(0, -3), "com");
    return "".concat(email.slice(0, atIndex), "@").concat(_correctedDomain);
  }
  if (parts.length !== 2) {
    return null;
  }
  var _parts = _slicedToArray(parts, 2),
    provider = _parts[0],
    extension = _parts[1];
  var correctedProvider = Object.prototype.hasOwnProperty.call(PROVIDER_TYPOS, provider) ? PROVIDER_TYPOS[provider] : null;
  if (!correctedProvider || extension !== 'com' && !COM_TYPOS.includes(extension)) {
    return null;
  }
  var correctedDomain = "".concat(correctedProvider, ".com");
  return domain === correctedDomain ? null : "".concat(email.slice(0, atIndex), "@").concat(correctedDomain);
}